import React, { useState } from 'react'

type Props = {
  defaultOpen?: boolean

  renderTrigger: (open: () => void) => React.ReactElement
  renderContent: (close: (...args) => void) => React.ReactElement

  onOpen?: () => void
  onClose?: (...args) => void
}

const Trigger: React.FC<Props> = ({
  defaultOpen,
  renderTrigger,
  renderContent,
  onOpen,
  onClose,
}) => {
  const [isOpen, setOpen] = useState(!!defaultOpen)

  const handleOpen = () => {
    if (!isOpen) {
      setOpen(true)
      onOpen && onOpen()
    }
  }

  const handleClose = (...args) => {
    if (isOpen) {
      setOpen(false)
      onClose && onClose(...args)
    }
  }

  return isOpen ? renderContent(handleClose) : renderTrigger(handleOpen)
}

export default Trigger
